export default "__VITE_ASSET__CYhTH6vL__"